import MeetingMinuteDetail from "./detail"
import "./index.less"
import { useParams } from "react-router-dom"

interface MeetingMinutePanelProps {
    goToUrl?: (url: string) => void
    projectId?: string
    projectName?: string //项目名称
}

export default function MeetingMinutePanel(props: MeetingMinutePanelProps) {

    const { meetingId } = useParams();

    return (
        <div className="meeting-record-panel">
            <div className="right-panel">
                {meetingId && (
                    <MeetingMinuteDetail
                        projectId={+props.projectId}
                        projectName={props.projectName}
                        meetingId={+meetingId}
                        goToUrl={props.goToUrl}
                    />
                )}
            </div>
        </div>
    )
}